<template>
  <div style="padding: 20px">
    <div class="counts-container">
      <div class="card card-data">
        <strong>Total de usuarios:</strong> {{ totalUsers() }}
      </div>
      <div class="card card-data">
        <strong>Total de Leads:</strong> {{ countSales() }}
      </div>
      <div class="card card-data">
        <strong>Total de Ventas Instaladas:</strong>
        {{ countInstalledSales() }}
      </div>
      <div class="card card-data">
        <strong>Total de Ventas Pendientes:</strong> {{ countPendingSales() }}
      </div>
      <div class="card card-data">
        <strong>Total de Cierres Perdidos:</strong>
        {{ countNotPendingNotInstalledSales() }}
      </div>
      <div class="card card-data">
        <strong>Comisiones por pagar:</strong> ${{ totalBalance.toFixed(2) }}
      </div>

      <!-- <div class="card card-data">
        <ol style="margin: 0; padding: 0">
          <div style="padding-bottom: 10px; margin: 0">
            <strong>Top 10 balances:</strong>
          </div>
          <li
            v-for="(balance, index) in topTenBalancesWithNames"
            :key="balance.userId"
            style="
              text-align: left;
              display: flex;
              justify-content: space-between;
            "
          >
            <span>
              <strong>{{ index + 1 }}.</strong>
              {{ balance.names }} {{ balance.lastnames }}:
            </span>
            <strong>${{ balance.balanceTotal.toFixed(2) }}</strong>
          </li>
        </ol>
      </div> -->
      <!-- <div class="card card-data">
        <ol style="margin: 0; padding: 0">
          <div style="padding-bottom: 10px; margin: 0">
            <strong>Top 10 Vendedores:</strong>
          </div>
          <li
            v-for="(seller, index) in topTenSellersWithNames"
            :key="seller.userId"
            style="
              text-align: left;
              display: flex;
              justify-content: space-between;
            "
          >
            <span>
              <strong>{{ index + 1 }}.</strong>
              {{ seller.names }} {{ seller.lastnames }}:
            </span>
            <strong style="padding-left: 10px">{{ seller.sales }}</strong>
          </li>
        </ol>
      </div> -->
    </div>
    <div
      v-if="usersByCity && Object.keys(usersByCity).length"
      class="city-list"
    >
      <p style="font-size: 18px; font-weight: bold">Usuarios por Ciudad</p>
      <ul
        class="list-group"
        style="display: flex; flex-direction: column; gap: 10px"
      >
        <li
          v-for="(count, city) in usersByCity"
          :key="city"
          class="card card-body"
          style="
            display: flex;
            justify-content: space-between;
            flex-direction: row;
          "
        >
          <strong>{{ city }}:</strong> {{ count }}
        </li>
      </ul>
    </div>
    <p v-else class="no-data">En Desarrollo</p>

    <div class="sellers-card">
      <h5 class="sellers-title">Quién está vendiendo</h5>
      <p class="sellers-help">
        Personas que refirieron al menos un lead creado en el mes, en cualquier
        estado. El pastel es el porcentaje por tipo de distribuidor. Las barras
        apiladas muestran cuántos de cada tipo están activos por campaña. Si el
        lead no tiene campaña, se agrupa con el nombre del mes. La participación
        es el porcentaje de ese tipo que vendió, sobre el censo actual.
      </p>

      <ul class="nav nav-pills sellers-tabs">
        <li
          v-for="(period, index) in activeSellersSummary.periods"
          :key="period.monthKey"
          class="nav-item"
        >
          <button
            type="button"
            class="nav-link"
            :class="{ active: activeSellersPeriod === period.monthKey }"
            @click="setActiveSellersPeriod(period.monthKey)"
          >
            {{ index === 0 ? "Mes actual" : period.label }}
          </button>
        </li>
      </ul>

      <div v-if="loadingActiveSellers" class="sellers-loading">
        <i class="fas fa-spinner fa-spin"></i>
        Cargando quién está vendiendo
      </div>

      <template v-else-if="selectedActiveSellersPeriod">
        <p class="sellers-total">
          <strong>{{ selectedActiveSellersPeriod.totalSellers }}</strong>
          {{
            selectedActiveSellersPeriod.totalSellers === 1
              ? "persona activa"
              : "personas activas"
          }}
          en {{ selectedActiveSellersPeriod.label }}
        </p>

        <p
          v-if="selectedActiveSellersPeriod.totalSellers === 0"
          class="no-data"
        >
          Nadie refirió en este mes.
        </p>

        <template v-else>
          <p class="sellers-help">
            Haz clic en una porción o en una barra para ver quiénes son.
          </p>
          <div class="row">
            <div class="col-lg-5 mb-3">
              <GChart
                :key="`pie-${activeSellersPeriod}`"
                type="PieChart"
                :resizeDebounce="500"
                :options="activeSellersPieChartOptions"
                :data="activeSellersPieData"
                @ready="onActiveSellersPieReady"
              />
            </div>
            <div class="col-lg-7 mb-3">
              <GChart
                :key="`campaign-${activeSellersPeriod}`"
                type="ColumnChart"
                :resizeDebounce="500"
                :options="campaignChartOptions"
                :data="activeSellersCampaignData"
                @ready="onActiveSellersCampaignReady"
              />
            </div>
          </div>
          <GChart
            :key="`participation-${activeSellersPeriod}`"
            type="ColumnChart"
            :resizeDebounce="500"
            :options="activeSellersParticipationOptions"
            :data="activeSellersParticipationData"
            @ready="onActiveSellersParticipationReady"
          />

          <div v-if="activeSellersSelection" class="sellers-list">
            <div class="sellers-list__header">
              <h6>
                {{ activeSellersSelectionTitle }}
                ({{ filteredActiveSellers.length }})
              </h6>
              <div class="sellers-list__actions">
                <button
                  type="button"
                  class="btn btn-sm btn-success"
                  :disabled="
                    filteredActiveSellers.length === 0 ||
                    downloadingActiveSellersExcel
                  "
                  @click="downloadActiveSellersExcel"
                >
                  <span
                    v-if="downloadingActiveSellersExcel"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                  ></span>
                  <i v-else class="fas fa-file-excel me-1"></i>
                  Descargar
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  @click="activeSellersSelection = null"
                >
                  Cerrar
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Empresa</th>
                    <th>Tipo</th>
                    <th v-if="activeSellersIncludeBranch">Local</th>
                    <th>Campaña</th>
                    <th>Referidos</th>
                    <th>Ventas</th>
                    <th>Conversión</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="person in filteredActiveSellers"
                    :key="person.userId"
                  >
                    <td>{{ person.names }} {{ person.lastnames }}</td>
                    <td>{{ person.companyName || "—" }}</td>
                    <td>{{ distributorTypeLabel(person.userType) }}</td>
                    <td v-if="activeSellersIncludeBranch">
                      {{
                        person.userType === "enterprise"
                          ? person.branch || "—"
                          : "—"
                      }}
                    </td>
                    <td>{{ (person.campaigns || []).join(", ") }}</td>
                    <td>{{ person.referrals }}</td>
                    <td>{{ person.installed || 0 }}</td>
                    <td>
                      {{ Number(person.conversionRate || 0).toFixed(1) }}%
                    </td>
                  </tr>
                  <tr v-if="filteredActiveSellers.length === 0">
                    <td
                      :colspan="activeSellersIncludeBranch ? 8 : 7"
                      class="text-center text-muted"
                    >
                      No hay personas en esta selección
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<style scoped>
.resumen-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.city-list {
  margin-bottom: 20px;
  width: fit-content;
}

.list-group {
  list-style-type: none;
  padding: 0;
}

.list-group-item {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 10px;
  margin-bottom: 5px;
}

.counts-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex-direction: column;
}

.count-card {
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 15px;
  flex: 1 1 calc(20% - 10px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.no-data {
  color: #6c757d;
  font-style: italic;
}
</style>

<script>
import { GChart } from "vue-google-charts";

const COLOR_BY_TYPE = {
  promoter: "#830b83",
  enterprise: "#2196f3",
};

export default {
  name: "Resumen",
  components: { GChart },
  data() {
    return {
      users: [],
      usersByCity: {},
      sales: [],
      totalBalance: 0,
      topTenBalancesWithNames: [],
      topTenSellersWithNames: [],
      loadingActiveSellers: true,
      downloadingActiveSellersExcel: false,
      activeSellersPeriod: "",
      activeSellersSelection: null,
      distributorTypes: [],
      activeSellersSummary: {
        loaded: false,
        periods: [],
      },
      activeSellersCampaignOptions: {
        title: "Personas activas por campaña",
        width: "100%",
        height: 360,
        isStacked: true,
        legend: { position: "top" },
        backgroundColor: "transparent",
        chartArea: { width: "78%", height: "65%" },
        bar: { groupWidth: "55%" },
        hAxis: {
          textStyle: { fontSize: 11 },
          slantedText: true,
          slantedTextAngle: 30,
        },
        vAxis: { title: "Personas", minValue: 0, format: "0" },
      },
      activeSellersParticipationOptions: {
        title: "Porcentaje de cada tipo que está vendiendo",
        width: "100%",
        height: 360,
        legend: { position: "none" },
        backgroundColor: "transparent",
        chartArea: { width: "78%", height: "65%" },
        bar: { groupWidth: "50%" },
        annotations: {
          alwaysOutside: true,
          textStyle: { fontSize: 12, bold: true, color: "#333" },
        },
        hAxis: {
          title: "Cantidad de usuarios de ese tipo",
          textStyle: { fontSize: 12 },
        },
        vAxis: {
          title: "Porcentaje",
          viewWindow: { min: 0, max: 100 },
          format: "#'%'",
        },
      },
    };
  },
  mounted() {
    this.getUsers();
    this.getSales();
    this.fetchTotalBalance();
    this.fetchActiveSellers();
  },
  methods: {
    getUsers() {
      this.$https
        .post("/administration/fetchUsersAdminStatistics", {
          tokenAuth: this.$store.state.tokenAuth,
          role: this.$store.state.user.role,
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          this.users = res.data.users;
          this.countUsersByCity(); // Now it's called AFTER data is set
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getSales() {
      this.$https
        .post("/administration/fetchSalesAdmin", {
          tokenAuth: this.$store.state.tokenAuth,
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          this.sales = res.data.sales;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    countSales() {
      return this.sales.length;
    },

    countInstalledSales() {
      return this.sales.filter(
        (sale) => sale.status === "INSTALADO: Contrato instalado",
      ).length;
    },

    countPendingSales() {
      return this.sales.filter((sale) => !sale.completed).length;
    },

    countNotPendingNotInstalledSales() {
      return this.sales.filter(
        (sale) =>
          sale.completed && sale.status !== "INSTALADO: Contrato instalado",
      ).length;
    },

    countUsersByCity() {
      this.usersByCity = this.users
        .filter((user) => user.isVerified) // Only count verified users
        .reduce((acc, user) => {
          let city = user.city || "Sin Ciudad"; // Default to "Sin Ciudad" if no city
          acc[city] = (acc[city] || 0) + 1;
          return acc;
        }, {});

      // Sort cities alphabetically, placing "Sin Ciudad" at the top
      const sortedCities = Object.keys(this.usersByCity).sort((a, b) => {
        if (a === "Sin Ciudad") return -1; // "Sin Ciudad" comes first
        if (b === "Sin Ciudad") return 1;
        return a.localeCompare(b); // Sort alphabetically
      });

      // Create a new object to maintain the sorted order
      this.usersByCity = sortedCities.reduce((acc, city) => {
        acc[city] = this.usersByCity[city];
        return acc;
      }, {});
    },
    totalUsers() {
      return this.users.length;
    },
    fetchTotalBalance() {
      this.$https
        .post("/administration/fetchWalletBalances", {
          tokenAuth: this.$store.state.tokenAuth,
          role: this.$store.state.user.role,
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          this.totalBalance = res.data.totalBalance;
          this.topTenBalancesWithNames = res.data.topTenBalancesWithNames;
          this.topTenSellersWithNames = res.data.topTenSellersWithNames;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    distributorTypeLabel(userType) {
      const match = this.distributorTypes.find((type) => type.key === userType);
      return match ? match.label : userType;
    },
    fileToken(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s-]/g, "")
        .trim()
        .replace(/\s+/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_+|_+$/g, "");
    },
    setActiveSellersPeriod(period) {
      this.activeSellersPeriod = period;
      this.activeSellersSelection = null;
    },
    fetchActiveSellers() {
      this.loadingActiveSellers = true;
      this.$https
        .post("/administration/activeSellers", {
          tokenAuth: this.$store.state.tokenAuth,
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.distributorTypes = res.data.types || [];
            this.activeSellersSummary = {
              loaded: true,
              periods: res.data.periods || [],
            };
            this.activeSellersPeriod = res.data.periods?.[0]?.monthKey || "";
          } else {
            this.$toast.error("Error al obtener quién está vendiendo");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error al obtener quién está vendiendo");
        })
        .finally(() => {
          this.loadingActiveSellers = false;
        });
    },
    async downloadActiveSellersExcel() {
      const period = this.selectedActiveSellersPeriod;
      const selection = this.activeSellersSelection;
      if (
        !period?.monthKey ||
        !selection ||
        this.downloadingActiveSellersExcel
      ) {
        return;
      }

      const body = {
        tokenAuth: this.$store.state.tokenAuth,
        userId: this.$store.state.user.userId,
        monthKey: period.monthKey,
      };
      const nameParts = [period.label.replace(/\s+/g, "_")];
      if (selection.kind === "userType") {
        body.userType = selection.key;
        nameParts.push(
          this.fileToken(this.distributorTypeLabel(selection.key)),
        );
      }
      if (selection.kind === "campaign") {
        body.campaign = selection.key;
        nameParts.push(this.fileToken(selection.key));
      }
      if (selection.kind === "campaignType") {
        body.userType = selection.userType;
        body.campaign = selection.campaign;
        nameParts.push(
          this.fileToken(this.distributorTypeLabel(selection.userType)),
        );
        nameParts.push(this.fileToken(selection.campaign));
      }

      this.downloadingActiveSellersExcel = true;
      try {
        const response = await this.$https.post(
          "/administration/activeSellersExcel",
          body,
          { responseType: "blob" },
        );
        const contentType = response.headers["content-type"] || "";
        if (contentType.includes("application/json")) {
          const text = await response.data.text();
          const payload = JSON.parse(text);
          this.$toast.error(
            payload.message || "Error al descargar quién está vendiendo",
          );
          return;
        }
        const filename = `Quien_esta_vendiendo_${nameParts.filter(Boolean).join("_")}.xlsx`;
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        this.$toast.error("Error al descargar quién está vendiendo");
      } finally {
        this.downloadingActiveSellersExcel = false;
      }
    },
    onActiveSellersPieReady(chart) {
      const googleCharts = window.google;
      if (!googleCharts?.visualization || !chart?.getSelection) return;
      googleCharts.visualization.events.addListener(chart, "select", () => {
        const selection = chart.getSelection();
        if (!selection.length || selection[0].row == null) {
          this.activeSellersSelection = null;
          return;
        }
        const key = this.activeSellersPieKeys[selection[0].row];
        this.activeSellersSelection = key ? { kind: "userType", key } : null;
      });
    },
    onActiveSellersCampaignReady(chart) {
      const googleCharts = window.google;
      if (!googleCharts?.visualization || !chart?.getSelection) return;
      googleCharts.visualization.events.addListener(chart, "select", () => {
        const selection = chart.getSelection();
        if (!selection.length || selection[0].row == null) {
          this.activeSellersSelection = null;
          return;
        }
        const campaign = this.activeSellersCampaignKeys[selection[0].row];
        const column = selection[0].column;
        if (column && column > 0) {
          const userType = this.distributorTypes[column - 1]?.key;
          this.activeSellersSelection =
            campaign && userType
              ? { kind: "campaignType", campaign, userType }
              : null;
          return;
        }
        this.activeSellersSelection = campaign
          ? { kind: "campaign", key: campaign }
          : null;
      });
    },
    onActiveSellersParticipationReady(chart) {
      const googleCharts = window.google;
      if (!googleCharts?.visualization || !chart?.getSelection) return;
      googleCharts.visualization.events.addListener(chart, "select", () => {
        const selection = chart.getSelection();
        if (!selection.length || selection[0].row == null) {
          this.activeSellersSelection = null;
          return;
        }
        const key = this.activeSellersParticipationKeys[selection[0].row];
        this.activeSellersSelection = key ? { kind: "userType", key } : null;
      });
    },
  },
  computed: {
    campaignChartOptions() {
      return {
        ...this.activeSellersCampaignOptions,
        colors: this.distributorTypes.map(
          (type) => COLOR_BY_TYPE[type.key] || "#9c27b0",
        ),
      };
    },
    selectedActiveSellersPeriod() {
      if (!this.activeSellersSummary.loaded) return null;
      return (
        this.activeSellersSummary.periods.find(
          (period) => period.monthKey === this.activeSellersPeriod,
        ) ||
        this.activeSellersSummary.periods[0] ||
        null
      );
    },
    activeSellersPieChartOptions() {
      const rows = this.selectedActiveSellersPeriod?.byUserType || [];
      return {
        title: "Porcentaje por tipo de distribuidor",
        width: "100%",
        height: 360,
        pieHole: 0.45,
        legend: { position: "right" },
        backgroundColor: "transparent",
        chartArea: { width: "90%", height: "80%" },
        pieSliceText: "percentage",
        colors: rows.map((row) => COLOR_BY_TYPE[row.userType] || "#9c27b0"),
      };
    },
    activeSellersPieKeys() {
      return (this.selectedActiveSellersPeriod?.byUserType || []).map(
        (row) => row.userType,
      );
    },
    activeSellersPieData() {
      const rows = this.selectedActiveSellersPeriod?.byUserType || [];
      if (!rows.length)
        return [
          ["Tipo", "Personas"],
          ["Sin datos", 0],
        ];
      return [
        ["Tipo", "Personas"],
        ...rows.map((row) => [
          this.distributorTypeLabel(row.userType),
          row.count,
        ]),
      ];
    },
    activeSellersCampaignKeys() {
      return (this.selectedActiveSellersPeriod?.byCampaign || []).map(
        (row) => row.campaign,
      );
    },
    activeSellersCampaignData() {
      const rows = this.selectedActiveSellersPeriod?.byCampaign || [];
      const header = [
        "Campaña",
        ...this.distributorTypes.map((type) => type.label),
      ];
      if (!rows.length) {
        return [header, ["Sin datos", ...this.distributorTypes.map(() => 0)]];
      }
      return [
        header,
        ...rows.map((row) => [
          row.campaign,
          ...this.distributorTypes.map(
            (type) => row.byUserType?.[type.key] || 0,
          ),
        ]),
      ];
    },
    activeSellersParticipationKeys() {
      return (this.selectedActiveSellersPeriod?.participation || []).map(
        (row) => row.userType,
      );
    },
    activeSellersParticipationData() {
      const rows = this.selectedActiveSellersPeriod?.participation || [];
      const header = [
        "Tipo",
        "Porcentaje",
        { role: "style" },
        { role: "annotation" },
      ];
      if (!rows.length) return [header, ["Sin datos", 0, "#ccc", ""]];
      return [
        header,
        ...rows.map((row) => [
          `${this.distributorTypeLabel(row.userType)} (${row.total})`,
          Number(row.percentage || 0),
          COLOR_BY_TYPE[row.userType] || "#9c27b0",
          `${Number(row.percentage || 0).toFixed(1)}% (${row.active}/${row.total})`,
        ]),
      ];
    },
    activeSellersIncludeBranch() {
      return this.filteredActiveSellers.some(
        (person) => person.userType === "enterprise",
      );
    },
    filteredActiveSellers() {
      const people = this.selectedActiveSellersPeriod?.sellers || [];
      const selection = this.activeSellersSelection;
      if (!selection) return [];
      if (selection.kind === "userType") {
        return people.filter((person) => person.userType === selection.key);
      }
      if (selection.kind === "campaign") {
        return people.filter((person) =>
          (person.campaigns || []).includes(selection.key),
        );
      }
      if (selection.kind === "campaignType") {
        return people.filter(
          (person) =>
            person.userType === selection.userType &&
            (person.campaigns || []).includes(selection.campaign),
        );
      }
      return [];
    },
    activeSellersSelectionTitle() {
      const selection = this.activeSellersSelection;
      if (!selection) return "";
      if (selection.kind === "userType") {
        return this.distributorTypeLabel(selection.key);
      }
      if (selection.kind === "campaign") return selection.key;
      return `${selection.campaign} · ${this.distributorTypeLabel(selection.userType)}`;
    },
  },
};
</script>

<style>
.card-data {
  padding: 20px;
  display: flex;
  width: fit-content;
  height: fit-content;
  flex-direction: row !important;
  gap: 10px;
}

.sellers-card {
  margin-top: 28px;
  padding: 20px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
}

.sellers-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
}

.sellers-help {
  color: #6c757d;
  margin-bottom: 12px;
}

.sellers-card .nav.nav-pills.sellers-tabs {
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  background: transparent;
  padding: 0;
  overflow: visible;
  white-space: normal;
}

.sellers-card .nav.nav-pills.sellers-tabs .nav-link {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  color: #555;
  margin-right: 0;
  padding: 8px 15px;
  font-size: 14px;
  font-weight: 600;
}

.sellers-card .nav.nav-pills.sellers-tabs .nav-link.active {
  background: #7d0c7e;
  border-color: #7d0c7e;
  color: #fff;
}

.sellers-card .nav.nav-pills.sellers-tabs .nav-link:hover:not(.active) {
  border-color: #7d0c7e;
  background: #fff;
  color: #7d0c7e;
}

.sellers-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6c757d;
}

.sellers-total {
  margin-bottom: 12px;
}

.sellers-list {
  margin-top: 16px;
}

.sellers-list__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.sellers-list__header h6 {
  margin: 0;
  font-weight: 700;
}

.sellers-list__actions {
  display: flex;
  gap: 8px;
}
</style>
